import { createFileRoute, notFound } from "@tanstack/react-router";
export const Route = createFileRoute("/ai-sandbox")({
  beforeLoad: () => { throw notFound(); },
});